import gql from 'graphql-tag';

export const DELETE_RV_PRODUCT_DISCOUNT = gql`
  mutation DeleteRVProductDiscount($discountId: ID!) {
    deleteRVProductDiscount(discountId: $discountId) {
      success
      error
    }
  }
`;
